import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var CommonUtils = function () {
  function CommonUtils() {
    _classCallCheck(this, CommonUtils);
  }

  _createClass(CommonUtils, null, [{
    key: "cloneJsonObject",
    value: function cloneJsonObject(jsonObject) {
      return JSON.parse(JSON.stringify(jsonObject));
    }
  }, {
    key: "isString",
    value: function isString(input) {
      return typeof input === "string";
    }
  }]);

  return CommonUtils;
}();